'use client';
import React, { useEffect, useState } from 'react';

interface LoadingBarProps {
  isLoading: boolean;
  className?: string;
}

const LoadingBar: React.FC<LoadingBarProps> = ({ isLoading, className = '' }) => {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setIsVisible(true);
      setProgress(0);

      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 90) {
            clearInterval(interval);
            return 90;
          }
          return prev + Math.random() * 30;
        });
      }, 200);

      return () => clearInterval(interval);
    } else {
      setProgress(100);

      const timeout = setTimeout(() => {
        setIsVisible(false);
        setProgress(0);
      }, 300);

      return () => clearTimeout(timeout);
    }
  }, [isLoading]);

  if (!isVisible) return null;

  return (
    <div className={`fixed top-0 right-0 left-0 z-50 h-1 bg-neutral-200 ${className}`}>
      <div
        className="from-brand-400 to-brand-300 h-full bg-gradient-to-r transition-all duration-300 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default LoadingBar;
